module.exports = __webpack_public_path__ + "media/images/icon-memo@3x-0b1501d6d4e85cc5f386b6631f8612ae.png";